/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type RelatedRecordItem = {
  summary: string;
  id: number;
  importance: number;
  relation: RelatedRecordItem.relation;
};

export namespace RelatedRecordItem {
  export enum relation {
    HISTORY = 'history',
    RELATED = 'related',
  }
}
